<template>
  <CFormGroup
    v-bind="{append, prepend, validFeedback, invalidFeedback,
        tooltipFeedback, description, wrapperClasses, class: computedClasses}"
    :style="wrapperAttrs.style"
    :class="wrapperAttrs.class"
  >
    <template #label>
      <slot name="label">
        <label v-if="label" :for="safeId" :class="labelClasses">
          {{label}}
        </label>
      </slot>
    </template>
    <template #input>
      <textarea
        v-bind="controlAttrs"
        :id="safeId"
        :class="inputClasses"
        :readonly="readonly || plaintext"
        :value="state"
        @input="onInput($event)"
        @change="onChange($event)"
      ></textarea>
    </template>
    <template v-for="slot in passSlots" #[slot]>
      <slot :name="slot"></slot>
    </template>
  </CFormGroup>
</template>

<script>
import CFormGroup from './CFormGroup.vue'
import { textareaProps as props } from './form-props'
import * as allFormMixins from './form-mixins'
const { initialValue, ...mixinMap } = allFormMixins
const mixins = Object.values(mixinMap)
const SLOTS = ['prepend', 'prepend-content', 'append-content', 'append', 'label-after-input', 'valid-feedback', 'invalid-feedback', 'description']

export default {
  name: 'CTextarea',
  inheritAttrs: false,
  components: { CFormGroup },
  mixins,
  props,
  emits: ['input', 'change', 'update:value', 'update:modelValue'],
  data () {
    return {
      state: initialValue(this),
      syncTimeout: null
    }
  },
  computed: {
    passSlots () {
      return SLOTS.filter((s) => this.$slots[s])
    }
  },
  methods: {
    onInput (e) {
      this.state = e.target.value
      this.$emit('input', this.state, e)
      this.$emit('update:modelValue', this.state)
      if (this.lazy === true) return
      clearTimeout(this.syncTimeout)
      this.syncTimeout = setTimeout(() => {
        this.$emit('update:value', this.state, e)
      }, this.lazy !== false ? this.lazy : 0)
    },
    onChange (e) {
      this.state = e.target.value
      this.$emit('change', this.state, e)
      this.$emit('update:value', this.state, e)
    }
  }
}
</script>
